/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceResponse } from './InvoiceResponse';
import {
    InvoiceResponseFromJSON,
    InvoiceResponseFromJSONTyped,
    InvoiceResponseToJSON,
    InvoiceResponseToJSONTyped,
} from './InvoiceResponse';

/**
 * 
 * @export
 * @interface PatientInvoicesResponse
 */
export interface PatientInvoicesResponse {
    /**
     * 
     * @type {Array<InvoiceResponse>}
     * @memberof PatientInvoicesResponse
     */
    invoices?: Array<InvoiceResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof PatientInvoicesResponse
     */
    truncated?: boolean;
}

/**
 * Check if a given object implements the PatientInvoicesResponse interface.
 */
export function instanceOfPatientInvoicesResponse(value: object): value is PatientInvoicesResponse {
    return true;
}

export function PatientInvoicesResponseFromJSON(json: any): PatientInvoicesResponse {
    return PatientInvoicesResponseFromJSONTyped(json, false);
}

export function PatientInvoicesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatientInvoicesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'invoices': json['invoices'] == null ? undefined : ((json['invoices'] as Array<any>).map(InvoiceResponseFromJSON)),
        'truncated': json['truncated'] == null ? undefined : json['truncated'],
    };
}

export function PatientInvoicesResponseToJSON(json: any): PatientInvoicesResponse {
    return PatientInvoicesResponseToJSONTyped(json, false);
}

export function PatientInvoicesResponseToJSONTyped(value?: PatientInvoicesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invoices': value['invoices'] == null ? undefined : ((value['invoices'] as Array<any>).map(InvoiceResponseToJSON)),
        'truncated': value['truncated'],
    };
}

